import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const setFormValues = hooks.useFormChange()
  const [user_city] = hooks.useActiveUser({ populate: ['staffinfo'], mutator: 'staffinfo.city' })

  const afterChangeModel = useCallback(Callbacks.afterChangeModelHandler(setFormValues, user_city), [setFormValues, user_city])

  const mergedProps = {
    afterChangeModel
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
